import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {ShipmentsService} from "../services/shipments.service";
import {ShipmentEvent} from "../services/shipment-event";
import * as moment from "moment/moment";
import {ActivatedRoute} from "@angular/router";
import {ShipmentDetailsPopupModalComponent} from "../shipment-details-popup-modal/shipment-details-popup-modal.component";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {ShipmentsModalComponent} from "../shipments-modal/shipments-modal.component";

@Component({
    selector: 'app-picking-list-actions',
    templateUrl: './picking-list-actions.component.html',
    styleUrls: ['./picking-list-actions.component.scss']
})
export class PickingListActionsComponent implements OnInit {
    protected search: any = {id: null};
    protected pickingList: any;
    protected alert: string = null;
    protected alertType = 'warning';

    @Input() mode: string;
    @Output() pickingListEvent = new EventEmitter<any>();
    // protected mode: string;
    protected pickingLists: any;

    @ViewChild('initialsInput', {static: false}) initialsInput: ElementRef;

    constructor(public shipmentsService: ShipmentsService, public activatedRoute: ActivatedRoute,  public ngbModal: NgbModal) {
    }

    ngOnInit(): void {
        //  this.mode = this.activatedRoute.snapshot.data.mode;
    }

    getPickingList() {
        this.pickingList = null;
        this.alert = null;
        this.alertType = 'warning';

        this.shipmentsService.getPickingList(this.search.id).subscribe((response: any) => {
            this.pickingList = response;
            setTimeout(() => {
                this.initialsInput.nativeElement.focus();
            }, 5);
            this.alert = response ? null : 'Plukliste blev ikke fundet';
        }, () => {
            this.pickingList = null;
            this.alert = 'Plukliste kunne ikke hentes';
            this.alertType = 'danger';
        });
    }

    protected sendEvent(shipment_status: string) {
        this.loading = true;
        this.shipmentsService.createShipmentEvent(ShipmentEvent.fromJSON({
            meta_data: {initials: this.search.initials},
            foreign_key: this.pickingList.id,
            model: 'ShipmentPickingLists',
            status_text: '',
            date: moment(),
            shipment_status: shipment_status
        })).then((status => {
            this.loading = false;
            this.pickingList = null;
            this.alert = 'Gemt';
            this.alertType = 'success';
            this.search.id = null;
            this.search.initials = null;
            this.pickingListEvent.next(true)
        }));
    }

    protected loading: boolean;

    protected showShipmentsModal(pickingList: any) {
        const modalRef = this.ngbModal.open(ShipmentsModalComponent, {size: 'xl'});
        modalRef.componentInstance.modal = modalRef;
        modalRef.componentInstance.shipments = pickingList.shipments;

    }

    protected reset() {
        this.search.id = null;
        this.search.initials = null;
        this.pickingList = null;
    }
}

